export class Logger {
  scope: string;

  constructor(scope: string) {
    this.scope = scope;
  }

  logInfo(message: string) {
    // eslint-disable-next-line no-console
    console.log(`[${new Date().toISOString()}][${this.scope}] ${message}`);
  }

  logError(message: string) {
    // eslint-disable-next-line no-console
    console.error(`[${new Date().toISOString()}][${this.scope}] ${message}`);
  }
}
